module.exports = __webpack_public_path__ + "3878c1ef890c3ce1f28f73a28670ef9b.jpg";